import React, { useState, useCallback, useEffect } from "react";
import { Switch } from "@fluentui/react-components";


const Toggle = (props) => {
    const { label, handleChange, checked, setChecked, StyleClass, labelPosition, loading , isDisabled = false } = props;

    const onChange = useCallback(
        (ev) => {
            handleChange(ev.currentTarget.checked);
        },
        [setChecked]
    );
    return (
        <>
            <Switch className={`${StyleClass} ToggleStyle`} disabled={loading || isDisabled} label={label} checked={checked} onChange={onChange} labelPosition={`${labelPosition ? labelPosition : 'after'}`} />
        </>
    );
}

export default Toggle;